import React from 'react';
import PropTypes from 'prop-types';
import { TextArea as SUITextArea } from 'semantic-ui-react';

import { View } from '../View';
import Text from '../Text';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const Container = style(View, styles.container);
const STextArea = style(SUITextArea, styles.textarea);
const SMessage = style(Text, styles.message);

const TextArea = ({ label, sublabel, message, required, error, ...restOfProps }) => (
  <Container>
    {label && (
      <Text weight="900" required={required}>
        {label}
      </Text>
    )}
    {sublabel && <Text size="small">{sublabel}</Text>}
    <STextArea error={error.toString()} {...restOfProps} />
    <Message message={message} error={error} />
  </Container>
);

const Message = ({ message, error }) =>
  message ? (
    <SMessage error={error} size="small">
      {message}
    </SMessage>
  ) : null;

TextArea.propTypes = {
  ...SUITextArea.propTypes,
  rows: PropTypes.number,
  label: PropTypes.string,
  sublabel: PropTypes.string,
  message: PropTypes.string,
  error: PropTypes.bool,
  required: PropTypes.bool
};

TextArea.defaultProps = {
  rows: 2,
  error: false,
  required: false
};

export default TextArea;
